import React from 'react';

import type { LogotypeProps } from '../../../types';

/**
 * Logotype Component - LifeFinder brand logo
 *
 * Displays the LifeFinder logo with optional animation for loading states.
 * Used consistently across authentication screens and splash screen.
 */
export const Logotype: React.FC<LogotypeProps> = ({ scaling = false, ...props }) => {
  const style: React.CSSProperties = {
    width: '50vmin',
    // Add pulsing animation for loading states
    ...(scaling && { animation: 'pulse 2s infinite' }),
  };

  return <img src="LifeFinder_logo_RGB.png" alt="LifeFinder Logo" style={style} {...props} />;
};

export default Logotype;
